export const accessibility = {
    heading: 'accessibility-heading',
    sectionBody:'accessibility-section-body',
}